export default "__VITE_ASSET__9213d9f0__"